import { render } from "./AppButton.vue?vue&type=template&id=6ab95c6f"
import script from "./AppButton.vue?vue&type=script&lang=js"
export * from "./AppButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__